/* global MutationObserver */
import { gsap } from 'gsap';
import { ScrambleTextPlugin } from 'gsap/ScrambleTextPlugin';

gsap.registerPlugin(ScrambleTextPlugin);

document.addEventListener('DOMContentLoaded', () => {
    const elements = document.querySelectorAll('.scramble-text[data-title]');

    elements.forEach((el) => {
        const runAnimation = () => {
            const word = el.getAttribute('data-title');
            if (!word) {return;}

            gsap.to(el, {
                duration: 1,
                scrambleText: {
                    text: word,
                    chars: 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ',
                    newClass: 'accent--text',
                    revealDelay: 0.5,
                    tweenLength: false,
                },
                ease: 'power2.inOut',
            });
        };

        // ✅ If already animated (AOS ran before JS)
        if (el.classList.contains('aos-animate')) {
            runAnimation();
            return;
        }

        // ✅ Watch for class change
        const observer = new MutationObserver(() => {
            if (el.classList.contains('aos-animate')) {
                runAnimation();
                observer.disconnect(); // run once
            }
        });

        observer.observe(el, {
            attributes: true,
            attributeFilter: ['class'],
        });
    });
});